import { buildMonetaryDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Compounding fee";

export function buildCompoundingFeeSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of compounding fee",
    toRows(essential?.monetary?.compoundingFee)
  );
}
